// Spinner Constants
export const [
  SET_SPINNER_FLAG
] = [
  "SET_SPINNER_FLAG"
];
